import { UnknownAction } from "redux";
import { isRichEditorAction } from "../actions/RichEditor.js";
import { RichEditorState } from "../types/index.js";

const initialState: RichEditorState = {};

const setEditorState = (
  state: RichEditorState,
  moduleId: string,
  isActive: boolean,
) => ({ ...state, [moduleId]: isActive });

const reducer = (state = initialState, action: UnknownAction) => {
  if (!isRichEditorAction(action)) {
    return state;
  }

  switch (action.type) {
    case "SET_EDITOR_ACTIVE_STATE":
      return setEditorState(state, action.moduleId, action.isActive);

    default:
      return state;
  }
};

export default reducer;
